import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { wa, pageEventTypes } from 'apps/analytics';

import {
  VIEW_TYPE_PREFERENCE_LIST,
  VIEW_TYPE_PREFERENCE_SHELF,
} from '../actions/catalogue';

const userPrefersListView = (preferListViewType) => preferListViewType === VIEW_TYPE_PREFERENCE_LIST;

function reportSwitchEvent(viewPreference) {
  wa.triggerPageEvent(pageEventTypes.FOP_VIEW_PREFERENCE_SWITCHED, { FOP_VIEW_PREFERENCE: viewPreference });
}

export default class FopViewTypeSwitch extends PureComponent {
  static propTypes = {
    fopViewPreference: PropTypes.oneOf([VIEW_TYPE_PREFERENCE_LIST, VIEW_TYPE_PREFERENCE_SHELF]),
    setViewTypePreferenceToList: PropTypes.func.isRequired,
    setViewTypePreferenceToShelf: PropTypes.func.isRequired,
  };

  onSwitchToListView = () => {
    if (!userPrefersListView(this.props.fopViewPreference)) {
      this.props.setViewTypePreferenceToList();
    }
    reportSwitchEvent(VIEW_TYPE_PREFERENCE_LIST);
  };

  onSwitchToShelfView = () => {
    if (userPrefersListView(this.props.fopViewPreference)) {
      this.props.setViewTypePreferenceToShelf();
    }
    reportSwitchEvent(VIEW_TYPE_PREFERENCE_SHELF);
  };

  render() {
    const preferListViewType = userPrefersListView(this.props.fopViewPreference);
    return (
      <div className="fop-view-switch">
        <fieldset>
          <legend>View:</legend>
          <button
            className="list"
            disabled={preferListViewType}
            onClick={this.onSwitchToListView}
            title="List view"
          />
          <button
            className="shelf"
            disabled={!preferListViewType}
            onClick={this.onSwitchToShelfView}
            title="Shelf view"
          />
        </fieldset>
      </div>
    );
  }
}
